module.exports = __webpack_public_path__ + "media/bootstrap-icons/archive-fill-bc6d1cd2.svg";